module.exports = __webpack_public_path__ + "static/facebook-41efe54daf01b07c248fa29793a0f446.svg";